
function debounce(func, delay) {
  let timer;

  return function(...args) {
    // Clear the previous timer
    clearTimeout(timer);

    // Set a new timer to invoke the function after the specified delay
    timer = setTimeout(() => {
      func.apply(this, args);
    }, delay);
  };
}


document.addEventListener( 'DOMContentLoaded', () => {
  setContentWrapperHeightOfCardsWithButtonButNoExcerpt();


  // Call debounce but you need to trigger it based on an event, e.g., window resize
  const debouncedResize = debounce(() => {
    setContentWrapperHeightOfCardsWithButtonButNoExcerpt();
  }, 500);

  // Attach debounced resize handler to the window resize event
  window.addEventListener('resize', debouncedResize);
  window.addEventListener('orientationchange', debouncedResize);

} );

const itemsPerPerRow = () => {
  if (window.matchMedia( '(min-width: 75rem)' ).matches) {
    return 3;
  }

  return 1;
}

/**
 * Set the height of the content wrapper for cards with a button but no excerpt.
 * Otherwise, the button will be misaligned.
 */
const setContentWrapperHeightOfCardsWithButtonButNoExcerpt = () => {
  const itemsPerRow = itemsPerPerRow();
  if (itemsPerRow === 1) {
    return;
  }

  const cardsWithButtonAndWithoutExcerpt = document.querySelectorAll( '.card--with-image.card--no-excerpt:has(.btn)' );

  if (cardsWithButtonAndWithoutExcerpt.length === 0) {
    return;
  }

  // Get the parent container of the cards.
  const parent = cardsWithButtonAndWithoutExcerpt[0].parentNode;

  // Select all '.card' elements within the parent.
  const cards = Array.from( parent.querySelectorAll( '.card' ) );

  // Get styles from the first card.
  const computedStyle = getComputedStyle( cards[0] );
  const padding = (parseFloat( computedStyle.getPropertyValue( 'padding' ) ) * 2) || 0;
  const gap = parseFloat( computedStyle.getPropertyValue( 'gap' ) ) || 0;

  // Initialize an object to store row groups.
  const rows = {};

  // Loop over each card without an excerpt to find its index and row number.
  cardsWithButtonAndWithoutExcerpt.forEach( (cardWithoutExcerpt) => {
    // Find the index of the current cardWithoutExcerpt within the full list of cards.
    const index = cards.indexOf( cardWithoutExcerpt );

    // Calculate the row number by dividing the index by itemsPerRow and rounding down.
    const rowNumber = Math.floor( index / itemsPerRow );

    // If the row doesn't exist in the rows object, initialize it.
    if (!rows[rowNumber]) {
      rows[rowNumber] = [];
    }

    // Add the card to the appropriate row group.
    rows[rowNumber].push( cardWithoutExcerpt );
  } );

  // Loop over each row group to find the tallest card.
  Object.keys( rows ).forEach( (rowNumber) => {
    const rowCards = rows[rowNumber];

    // Remove property to reset the height of the content wrapper.
    rowCards.forEach( (card) => card.style.removeProperty( '--content-height' ) );

    // Find the tallest card in the current row
    const maxHeight = Math.max( ...rowCards.map( (card) => card.clientHeight ) );

    // Set the tallest height as an inline style for each card in the row
    rowCards.forEach( (card) => {
      // Get `.card__image` and `.btn` elements and calculate their combined height
      const imageElement = card.querySelector( '.card__image' );
      const buttonElement = card.querySelector( '.btn' );
      const imageHeight = imageElement ? imageElement.clientHeight : 0;
      const buttonHeight = buttonElement ? buttonElement.clientHeight : 0;

      const amountOfGaps = card.children.length - 1;
      const totalGap = gap * amountOfGaps;

      // Calculate the height for `contentWrapper` by subtracting the height of the image, button, and total gap from the max height.
      const contentHeight = maxHeight - (imageHeight + buttonHeight + totalGap + padding);

      card.style.setProperty( '--content-height', `${contentHeight}px` );
    } );
  } );
}


